/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import _sortBy from "lodash/sortBy";
import { jsx } from "@emotion/react";
import ActionItemCard, { Statuses } from "./ActionItemCard";
import {
  CardList,
  CheckListWidget,
  CompletionRules,
  LockedArrow,
  ProgressBar,
  TitleCard,
} from "./Widget";
import SuccessModal from "./SuccessModal";
import LockedModal from "./LockedModal";

const ChecklistActionOrder = {
  Ordered: "Ordered",
  Unordered: "Unordered",
};

export const ActionItemTypes = {
  ProprietarySpecific: "Proprietary Specific",
  ProprietaryGeneral: "Proprietary General",
  ThirdParty: "Third Party",
  OpenTextQuestion: "Open Text Question",
};

const isOrdered = (checklistOrder) =>
  checklistOrder === ChecklistActionOrder.Ordered;

const sortByCompletion = (actionItems) =>
  _sortBy(actionItems, (actionItem) => actionItem.IsComplete);
const sortByOrderNumber = (actionItems) =>
  _sortBy(actionItems, (actionItem) => actionItem.OrderNumber);

const checkForCompletion = (completionRule, actionItems, completeAny) => {
  switch (completionRule) {
    case CompletionRules.all: {
      return (
        actionItems.every((actionItem) => actionItem.IsComplete) &&
        actionItems.length
      );
    }
    case CompletionRules.setAmount: {
      return (
        actionItems.filter((actionItem) => actionItem.IsComplete).length >=
        completeAny
      );
    }
    case CompletionRules.requiredOnly: {
      return (
        actionItems.filter(
          (actionItem) =>
            actionItem.IsComplete && actionItem.Requirement === "Required"
        ) >=
        actionItems.filter(
          (actionItem) => actionItem.Requirement === "Required"
        )
      );
    }
  }
};

export const CheckList = ({
  actionItemsData,
  completeAny,
  completionRule,
  label,
  heading,
  isChecklistLocked,
  checklistOrder,
  subHeading,
  completionMessage,
  goToSignUp,
}) => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isLockedModalOpen, setIsLockedModalOpen] = useState(false);
  const [actionItems, setActionItems] = useState(actionItemsData);

  const widgetRef = useRef();

  useEffect(() => {
    setActionItems(sortByCompletion(sortByOrderNumber(actionItems)));
  }, [actionItemsData]);

  useEffect(() => {
    if (checkForCompletion(completionRule, actionItems)) {
      setIsSuccessModalOpen(true);
    }
  }, [actionItems]);

  useEffect(() => {
    setIsLockedModalOpen(isChecklistLocked);
  }, [isChecklistLocked]);

  const getActionItemStatus = (actionItem, currentIndex) => {
    const prevActionItem = currentIndex !== 0 && actionItems[currentIndex - 1];
    if (
      isOrdered(checklistOrder) &&
      currentIndex !== 0 &&
      !prevActionItem.IsComplete
    ) {
      return Statuses.Locked;
    } else if (actionItem.IsComplete) {
      return Statuses.Complete;
    } else {
      return Statuses.Active;
    }
  };

  return (
    <CheckListWidget widgetRef={widgetRef}>
      <TitleCard label={label} heading={heading} subHeading={subHeading} />
      <CardList>
        <ProgressBar
          heading="Checklist Progress"
          completionRule={completionRule}
          actionItems={actionItems}
          completeAny={completeAny}
        />
        {sortByCompletion(sortByOrderNumber(actionItems)).map(
          (actionItem, index) => (
            <React.Fragment key={actionItem.ActionItemTitle}>
              {isOrdered(checklistOrder) && index !== 0 && <LockedArrow />}
              <ActionItemCard
                className="row no-gutter"
                status={getActionItemStatus(actionItem, index)}
                actionItem={actionItem}
                setActionItems={setActionItems}
              />
            </React.Fragment>
          )
        )}
      </CardList>
      <SuccessModal
        open={isSuccessModalOpen}
        onClose={() => setIsSuccessModalOpen(false)}
        blurbText={completionMessage}
        heading="Checklist Completed!"
      />
      <LockedModal open={isLockedModalOpen} goToSignUp={goToSignUp} />
    </CheckListWidget>
  );
};
